import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useAccountsStore } from '@lib/store';
import type { AccountEntity, CardsEntity } from '@shared/api';

export const useAccountContext = (): { id?: string; account: AccountEntity | null; card: CardsEntity | null } => {
  const { id } = useParams<{ id: string }>();

  const accounts = useAccountsStore((state) => state.data);

  return useMemo(() => {
    const currentAccount =
      accounts.find((account) => String(account.mainCard?.id) == id || account.supplementCards?.some((card) => String(card.id) == id)) || null;

    const defaultAccount = accounts[0] || null;
    const account = currentAccount || defaultAccount;

    const currentCard =
      (account && (String(account.mainCard?.id) === id ? account.mainCard : account.supplementCards?.find((card) => String(card.id) == id))) || null;

    const card = currentCard || account?.mainCard || null;

    return { id, account, card };
  }, [id, accounts]);
};
